/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * @nullable
 */
export type VideoSurveyImpressionInputScenarioId = Cuid | null
